import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
var routerArr=[
    {
        path: '/login',
        component: () => import('@/components/login.vue'),
        meta:{
            type:'no',    //是否需要登录权限
            keepAlive: false, //是否缓存此组件
            title:'登录'
        }
    },
    {
        path: '/index',
        component: () => import('@/components/index.vue'),
        meta:{
            type:'login',    //是否需要登录权限
            keepAlive: false, //是否缓存此组件
            title:'首页'
        }
    },        
    {
        path: '/404',
        component: () => import('@/components/404.vue'),
        meta:{
            type:'no',    //是否需要登录权限
            keepAlive: false, //是否缓存此组件
            title:'错误'
        }
    },          
    {
        path: '/home',
        name: 'Home',
        component: () => import('../home.vue'), //父级文件位置，包含<router-view></router-view>
        children: [
            {
                path: 'index',
                component: () => import('@/components/index.vue'),
                meta:{
                    type:'no',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'首页'
                }
            },          
        ],
    },
    {
        path: '/admin',
        name: 'Admin',
        component: () => import('../Layout.vue'), //父级文件位置，包含<router-view></router-view>
        children: [],
    },
    {
        path: '/admin/faculty',
        name: 'Admin',
        component: () => import('../Layout.vue'), //父级文件位置，包含<router-view></router-view>
        children: [    
            {
                path: 'teacher/info',
                component: () => import('@/components/faculty/teacherInfo.vue'),
                name:'人事详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'postdoctor/info',
                component: () => import('@/components/faculty/postdoctorInfo.vue'),
                name:'人事详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'allowance/info',
                component: () => import('@/components/faculty/allowanceInfo.vue'),
                name:'业绩津贴',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'payroll/info',
                component: () => import('@/components/faculty/payrollInfo.vue'),
                name:'工资发放',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'yearBonus/info',
                component: () => import('@/components/faculty/yearBonusInfo.vue'),
                name:'年终奖',
                meta:{
                    type:'login',
                    keepAlive: false,
                    title:'年终奖详情',
                }
            },
        ],
    },
    {
        path: '/admin/undergraduate',
        name: 'Admin',
        component: () => import('../Layout.vue'), //父级文件位置，包含<router-view></router-view>
        children: [    
            {
                path: 'culture/syllabus/info',
                component: () => import('@/components/undergraduate/culture/syllabusInfo.vue'),
                name:'课程大纲详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'culture/books/info',
                component: () => import('@/components/undergraduate/culture/booksInfo.vue'),
                name:'课程大纲详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'culture/course/info',
                component: () => import('@/components/undergraduate/culture/courseInfo.vue'),
                name:'课程详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'culture/teaching/info',
                component: () => import('@/components/undergraduate/culture/teachingInfo.vue'),
                name:'教材详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'quality/classroom/info',
                component: () => import('@/components/undergraduate/quality/classroomInfo.vue'),
                name:'教材详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:' 课堂教学质量详情',
                }
            },
            {
                path: 'research/build/info',
                component: () => import('@/components/undergraduate/research/buildInfo.vue'),
                name:'课程建设项目详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'research/reform/info',
                component: () => import('@/components/undergraduate/research/reformInfo.vue'),
                name:'教学与改革详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'research/achievements/info',
                component: () => import('@/components/undergraduate/research/achievementsInfo.vue'),
                name:'教学成果奖详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'student/subject/info',
                component: () => import('@/components/undergraduate/student/subjectInfo.vue'),
                name:'学科竞赛详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'student/thesis/info',
                component: () => import('@/components/undergraduate/student/thesisInfo.vue'),
                name:'本科论文详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'culture/examsearly/info',
                component: () => import('@/components/undergraduate/culture/examsEarlyInfo.vue'),
                name:'提前考',
                meta:{
                    type:'login',    //是否需要登权限
                    keepAlive: false, //是否缓存此组件
                    title:' 提前考详情',
                }
            },
            {
                path: 'culture/parallelClass/info',
                component: () => import('@/components/undergraduate/culture/parallelClassInfo.vue'),
                name:'平行班考试',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'平行班考试详情',
                }
            },
            {
                path: 'quality/spotCheck/info',
                component: () => import('@/components/undergraduate/quality/spotCheckInfo.vue'),
                name:'试卷抽查',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'试卷抽查',
                }
            },
            {
                path: 'culture/exchange/info',
                component: () => import('@/components/undergraduate/culture/exchangeInfo.vue'),
                name:'调代课',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'调代课',
                }
            },
            {
                path: 'culture/syllabusAndBooks/info',
                component: () => import('@/components/undergraduate/culture/syllabusAndBooksInfo.vue'),
                name:'课程大纲详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'quality/paperCheck/info',
                component: () => import('@/components/undergraduate/quality/paperCheckInfo.vue'),
                name:'课程大纲详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'quality/selfCheck/info',
                component: () => import('@/components/undergraduate/quality/selfCheckInfo.vue'),
                name:'课程大纲详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'nightCoaching/info',
                component: () => import('@/components/undergraduate/nightCoachingInfo.vue'),
                name:'课程大纲详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'nightCoaching/timeSet',
                component: () => import('@/components/undergraduate/nightCoachingTimeSet.vue'),
                name:'课程大纲详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'assess/info',
                component: () => import('@/components/undergraduate/assessInfo.vue'),
                name:'课程大纲详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'wholeMentoring/info',
                component: () => import('@/components/undergraduate/wholeMentoringInfo.vue'),
                name:'全程导师详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
        ],
    },
    {
        path: '/admin/master',
        name: 'Admin',
        component: () => import('../Layout.vue'), //父级文件位置，包含<router-view></router-view>
        children: [    
            {
                path: 'course/info',
                component: () => import('@/components/master/courseInfo.vue'),
                name:'工会详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'student/info',
                component: () => import('@/components/master/studentInfo.vue'),
                name:'工会详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'concealedEvaluation/info',
                component: () => import('@/components/master/concealedEvaluationInfo.vue'),
                name:'工会详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
        ],
    },
    {
        path: '/admin/office',
        name: 'Admin',
        component: () => import('../Layout.vue'), //父级文件位置，包含<router-view></router-view>
        children: [    
            {
                path: 'union/info',
                component: () => import('@/components/office/unionInfo.vue'),
                name:'工会详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'administration/meetingRooms/list',
                component: () => import('@/components/office/administration/meetingRoomsList.vue'),
                name:'会议室预约',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'seal/info',
                component: () => import('@/components/office/sealInfo.vue'),
                name:'用印详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
        ],
    },
    {
        path: '/admin/research',
        name: 'Admin',
        component: () => import('../Layout.vue'), //父级文件位置，包含<router-view></router-view>
        children: [    
            {
                path: 'thesis/info',
                component: () => import('@/components/research/thesisInfo.vue'),
                name:'论文详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
            {
                path: 'assess/info',
                component: () => import('@/components/research/assessInfo.vue'),
                name:'考核详情',
                meta:{
                    type:'login',    //是否需要登录权限
                    keepAlive: false, //是否缓存此组件
                    title:'详情页',
                }
            },
        ],
    },
    {
        path: '/admin/faculty/staffAssessment',
        name: 'Admin',
        component: () => import('../Layout.vue'),
        children: [    
            {
                path: '',
                component: () => import('@/components/faculty/staffAssessment.vue'),
                name:'院聘行政人员考核',
                meta:{
                    type:'login',
                    keepAlive: false,
                    title:'院聘行政人员考核',
                }
            },
            {
                path: 'info',
                component: () => import('@/components/faculty/staffAssessmentInfo.vue'),
                name:'考核详情',
                meta:{
                    type:'login',
                    keepAlive: false,
                    title:'考核详情',
                }
            },
        ],
    },
    {
        path: '/mobile',
        component: () => import('@/components/mobile/index.vue'),
        name:'',
        meta:{
            type:'no',    //是否需要登录权限
            keepAlive: false, //是否缓存此组件
            title:'移动端'
        }
    },
    {
        path: '/mobile/list',
        component: () => import('@/components/mobile/list.vue'),
        name:'',
        meta:{
            type:'no',    //是否需要登录权限
            keepAlive: false, //是否缓存此组件
            title:'移动端'
        }
    },
    {
        path: '/mobile/info',
        component: () => import('@/components/mobile/info.vue'),
        name:'',
        meta:{
            type:'no',    //是否需要登录权限
            keepAlive: false, //是否缓存此组件
            title:'移动端'
        }
    },
    {
        path: '*',
        redirect: '/404', 
    },
]
export default new Router({
    // mode: 'history',  //打包使用history模式需要配合nginx使用
    routes: routerArr
})
